import { 
  doc, 
  getDoc,
  setDoc, 
  updateDoc,
  Timestamp
} from 'firebase/firestore'
import { db } from './config'
import { getCurrentUser } from './auth'
import { errorHandler } from '@/utils/errorHandler'

export interface AdminSettings {
  // Benachrichtigungs-E-Mail-Adresse für Kontaktformular-Submissions
  notificationEmail?: string
  
  // Meta-Daten
  updatedAt: Date
  updatedBy?: string
}

// Standard-Admin-Einstellungen
const DEFAULT_ADMIN_SETTINGS: Omit<AdminSettings, 'updatedAt' | 'updatedBy'> = {
  notificationEmail: undefined
}

// Admin-Einstellungen abrufen
export const getAdminSettings = async (): Promise<AdminSettings | null> => {
  if (!db) {
    throw new Error('Firestore ist nicht initialisiert')
  }
  
  try {
    const settingsRef = doc(db, 'adminSettings', 'main')
    const settingsSnap = await getDoc(settingsRef)
    
    if (!settingsSnap.exists()) {
      return null
    }
    
    const data = settingsSnap.data()
    return {
      ...data,
      updatedAt: data.updatedAt?.toDate() || new Date()
    } as AdminSettings
  } catch (error) {
    errorHandler.handle(error, 'getAdminSettings')
    return null
  }
}

// Admin-Einstellungen aktualisieren
export const updateAdminSettings = async (data: Partial<AdminSettings>): Promise<void> => {
  if (!db) {
    throw new Error('Firestore ist nicht initialisiert')
  }
  
  try {
    const user = getCurrentUser()
    if (!user) {
      throw new Error('Nicht authentifiziert')
    }
    
    const settingsRef = doc(db, 'adminSettings', 'main')
    const existingDoc = await getDoc(settingsRef)
    
    const updateData: Record<string, any> = {
      ...data,
      updatedAt: Timestamp.now(),
      updatedBy: user.uid
    }
    
    // Entferne undefined Werte
    Object.keys(updateData).forEach(key => {
      if (updateData[key] === undefined) {
        delete updateData[key]
      }
    })
    
    if (existingDoc.exists()) {
      await updateDoc(settingsRef, updateData)
    } else {
      // Erstelle Dokument mit Standard-Werten falls nicht vorhanden
      await setDoc(settingsRef, {
        ...DEFAULT_ADMIN_SETTINGS,
        ...updateData
      })
    }
  } catch (error) {
    errorHandler.handle(error, 'updateAdminSettings')
    throw error
  }
}

// Standard-Admin-Einstellungen zurückgeben (für Fallback)
export const getDefaultAdminSettings = (): Omit<AdminSettings, 'updatedAt' | 'updatedBy'> => {
  return DEFAULT_ADMIN_SETTINGS
}








